// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"2882":"dashboard-layout","9966":"dashboard"}[chunkId] || chunkId) + "." + {"325":"f06c2538","2682":"5ccffb6a","2759":"a96b685e","2882":"e66f5b3b","7746":"30a91f21","9966":"ed0c7f7b"}[chunkId] + ".css";
};